var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-icon"},[_c('span',{staticClass:"text-center dot-edit-icon",class:_vm.priority == '2' ? 'low' : _vm.priority == '1' ? 'high' : 'normal'})])}
var staticRenderFns = []

export { render, staticRenderFns }